var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowDownIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.944 13.842a1.502 1.502 0 0 0 2.124 0l9-9a1.502 1.502 0 0 0-2.124-2.124l-7.94 7.941-7.941-7.936a1.502 1.502 0 0 0-2.124 2.123l9 9 .005-.004Z"
})));
export default SvgArrowDownIcon;